import { createContext } from 'react';

export const CurrentUserContext = createContext(null);

export const NotificationContext = createContext(null);

export const AppContext = createContext(null);
export const ProgressContext = createContext(null);
